module.exports = __webpack_public_path__ + "img/trinket.09e0041d.png";